import Strings from '../../../../Strings';

export const accountTypes = ['user', 'bot', 'service_account', 'api_key'];

export const getAccountTypeLabel = accountType => ({
  user: Strings.accountTypeUser,
  bot: Strings.bot,
  service_account: Strings.accountTypeServiceAccount,
  api_key: Strings.accountTypeApiKey,
}[accountType]);
